import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bgm",
  "use": "icon-bgm-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-bgm\">\n\t<path fill=\"none\" d=\"M0 0h24v24H0z\" />\n\t<path d=\"M22,4.2v16a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4.2a1,1,0,0,1,1-1H21A1,1,0,0,1,22,4.2ZM4,19.2H20V5.2H4Zm13-12V15a2.23,2.23,0,0,1-1.72,2.14,2.35,2.35,0,0,1-2.6-1,2.13,2.13,0,0,1,.37-2.67A2.39,2.39,0,0,1,15,12.79V9.2H11V15a2.23,2.23,0,0,1-1.72,2.14,2.35,2.35,0,0,1-2.6-1,2.13,2.13,0,0,1,.37-2.67,2.39,2.39,0,0,1,2-.63V7.2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol